module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAc0lEQVR42u3QQRGAUABCQeLYwLpGM4R3/skULDMvAJu2WW76PAAAAAAAAAAAAAAAbb7r7lIAAAAAAAAAAAAAAAAA8Lc2AAAAAAAAAAAAAAAAAGjyvF0KAAAAAAAAAAAAAAAAAAAsBwAAAAAAAAAAAADAaAfsaTVCkavuDwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Luxembourg.png
// module id = jsR/
// module chunks = 0 62 63